export default function() {

	const salesTaxCalculators = document.getElementsByClassName('block-sales-tax-calculator');

	if (salesTaxCalculators.length > 0) {

		for (const calculator of salesTaxCalculators) {

			// Inputs
			const stateField = calculator.querySelector('[data-calculator-state]');
			const costField = calculator.querySelector('[data-calculator-cost]');

			// Outputs
			const stateSalesTaxRate = calculator.querySelector('[data-calculator-state-sales-tax-rate]');
			const salesTaxSavings = calculator.querySelector('[data-calculator-sales-tax-savings]');

			stateField.addEventListener('input', event => {
				handleInput(stateField, costField, stateSalesTaxRate, salesTaxSavings, calculator)
			});

			costField.addEventListener('input', event => {

				formatCostField(costField);

				handleInput(stateField, costField, stateSalesTaxRate, salesTaxSavings, calculator)
			});
		}
	}

	/**
	 * Handle calculator input to change the displayed outputs
	 *
	 * @param {HTMLElement} stateField - State <select> field which with <option> set up as stateSalesTaxRate:stateName (value:label)
	 * @param {HTMLElement} costField - The <input> field for the vehicle cost to be purchased
	 * @param {HTMLElement} stateSalesTaxRate - A <div> to output the selected state sales tax rate
	 * @param {HTMLElement} salesTaxSavings - A <div> to output the total savings or another message if the state has no sales tax
	 * @param {HTMLElement} calculator - The <div> parent block wrapper
	 */
	const handleInput = (stateField, costField, stateSalesTaxRate, salesTaxSavings, calculator) => {

		const noSalesTaxClass = 'no-sales-tax';
		const hasValueClass = 'has-value';

		// Different styles based on whether it has values or not
		if (costField?.value) {
			costField.closest('.calculator-row').classList.add(hasValueClass);
		} else {
			costField.closest('.calculator-row').classList.remove(hasValueClass);
		}

		if (stateField?.value) {
			stateField.closest('.calculator-row').classList.add(hasValueClass);

			const stateName = stateField?.options?.[stateField.selectedIndex]?.text;
			const stateNameDynamicMatch = '[[STATE]]';

			// Displayed under the <select>
			const noSalesTaxMessageShort = stateField?.dataset?.messageShort?.replaceAll(stateNameDynamicMatch, stateName);
			// Displayed under the savings label
			const noSalesTaxMessageLong = salesTaxSavings?.dataset?.messageLong?.replaceAll(stateNameDynamicMatch, stateName);

			stateSalesTaxRate.textContent = `${stateField.value}% tax rate`;

			// If there is no sales tax in the selected state, display custom messages
			if (Number(stateField.value) === 0) {
				stateSalesTaxRate.innerHTML = noSalesTaxMessageShort;
				salesTaxSavings.innerHTML = noSalesTaxMessageLong;
				salesTaxSavings.closest('.calculator-row').classList.add(hasValueClass);
				calculator.classList.add(noSalesTaxClass);
			} else if (costField.dataset.valueNumeric) {
				// Has sales tax and purchase price is set, so display the calculated sales tax savings
				const totalSalesTax = costField.dataset.valueNumeric * (stateField.value / 100) || 0;
				salesTaxSavings.textContent = `$${formattedDollars(totalSalesTax)}`;
				calculator.classList.remove(noSalesTaxClass);
				salesTaxSavings.closest('.calculator-row').classList.add(hasValueClass);
			} else {
				// Missing purchase price so clear any sales tax savings values
				salesTaxSavings.textContent = '$';
				calculator.classList.remove(noSalesTaxClass);
				salesTaxSavings.closest('.calculator-row').classList.remove(hasValueClass);
			}
		} else {
			// No state selected so clear any tax rate or sales tax savings values
			stateSalesTaxRate.textContent = '';
			salesTaxSavings.textContent = '$';
			stateField.closest('.calculator-row').classList.remove(hasValueClass);
			salesTaxSavings.closest('.calculator-row').classList.remove(hasValueClass);
			calculator.classList.remove(noSalesTaxClass);
		}
	}

	/**
	 * Format the cost field to have commas where needed
	 *
	 * @param {HTMLElement} costField
	 */
	const formatCostField = (costField) => {

		let value = costField.value;

		// Remove all non-numeric characters and cap at 9 digits
		value = value.replace(/\D/g, '').slice(0, 9);
		costField.dataset.valueNumeric = value;

		// Format the number with commas
		value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

		costField.value = value;
	}

	/**
	 * Display numbers with dollar format and no cents
	 *
	 * @param {number} value
	 * @return string
	 */
	const formattedDollars = (value) => {

		const options = {
			style: 'decimal',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		};

		return new Intl.NumberFormat('en-US', options).format(value);
	}
}
